module.exports = __webpack_public_path__ + "static/media/xylophoneIcon.0f0e05a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/img/xylophoneIcon.png
// module id = 110
// module chunks = 0